export enum MessageStatusEnum {
    SUCCESS,
    ERROR,
    ALERT,
    INFO,
}
